module.exports = __webpack_public_path__ + "static/media/integral_card_3.46ff6f27.png";